import cx from 'classnames'
import * as React from 'react'

import type { PageLoginViewModel } from '@/modules/Navigation/view-models/PageLoginViewModel'
import type { NavigationLogoViewModel } from '@/view-models/NavigationLogoViewModel'
import BaseButton from '../BaseButton/BaseButton'
import NavigationLogo from '../NavigationLogo/NavigationLogo'
import NotificationCount from '../NotificationCount/NotificationCount'
import PageLogin from '../PageLogin/PageLogin'
import styles from './headerMobile-style.css'

type Props = {
  logo: NavigationLogoViewModel
  pageLogin?: PageLoginViewModel
  onToggle: (...args: Array<any>) => any
  isOpen: boolean
  notificationCount?: string
  alignLogin?: 'right' | 'left'
}
type State = {}
const eventMeta = {
  event: 'burgermenu',
}

class HeaderMobile extends React.Component<Props, State> {
  static displayName = 'HeaderMobile'
  static defaultProps = {}

  get renderPageLogin() {
    const pageLogin = this.props.pageLogin
    const {alignLogin} = this.props
    if (!pageLogin) return null

    return (
      <PageLogin items={pageLogin.links} title={pageLogin.title} loggedIn={pageLogin.loggedIn} align={alignLogin} />
    )
  }

  render() {
    const { logo, onToggle, isOpen, notificationCount } = this.props

    return (
      <div className={styles.headerMobile}>
        <BaseButton onClick={onToggle} eventMeta={isOpen ? {} : eventMeta}>
          <div className={cx(styles.burgerHolder, isOpen && styles.open)}>
            <div className={cx(styles.burger, isOpen && styles.open)}>
              <span />
              <span />
              <span />
            </div>
            {notificationCount && <NotificationCount notificationCount={notificationCount} />}
          </div>
        </BaseButton>
        <NavigationLogo {...logo} className={styles.logo_mobile} />
        <div>{this.renderPageLogin}</div>
      </div>
    )
  }
}

export default HeaderMobile